import { CardUnified } from './CardUnified';

/**
 * CardMyCollection 컴포넌트 (하위 호환 래퍼)
 *
 * CardUnified 의 variant="myCollection" 으로 위임한다. 신규 코드는 CardUnified 를 직접 사용 권장.
 *
 * @param {Object} collection - 컬렉션 데이터 [Required]
 * @param {string} date - (레거시 prop, 미사용) [Optional]
 * @param {number} rd - 모서리 둥글기(px) [Optional, 기본값: 8]
 * @param {('full'|'bottom'|'left'|'right'|'top')} borderType - 테두리 형태 [Optional, 기본값: 'full']
 * @param {boolean} isMobile - 모바일 레이아웃 여부 [Optional]
 * @param {boolean} isMe - 내 컬렉션 여부 [Optional, 기본값: false]
 *
 * Example usage:
 * <CardMyCollection collection={collection} isMobile={isMobile} isMe />
 */
export const CardMyCollection = ({
  collection,
  rd = 8,
  borderType = 'full',
  isMobile,
  isMe = false,
}) => (
  <CardUnified
    variant="myCollection"
    collection={collection}
    rd={rd}
    borderType={borderType}
    isMobile={isMobile}
    isMe={isMe}
  />
);
